import memoizeLatest from '@/lib/memoize-latest'
import { getUriCategory } from '@/store/page/selectors'
import select from '@/utils/select'
import Vue from 'vue'
import './oz-amenity.scss'

const fixUrlBuilder = memoizeLatest((location) => {
  const base = new URL(location, document.location)

  return function (path) {
    return new URL(path, base).href
  }
})

export default Vue.component('oz-amenity', {

  props: {
    value: { type: Array, required: true },
    amenity: { type: Object, required: true },
  },

  data () {
    return {
      location: document.location.href,
    }
  },

  emits: ['change'],

  render () {
    let content = <new-l-checkbox
      checked={this.value}
      value={this.amenity.id}
      data-cy={this.amenity.text}
      onChange={this.onChange}
    >
      {this.amenity.text}
    </new-l-checkbox>

    if (this.amenity.path && this.amenity.facets > 3) {
      content = <a class="oz-amenity__hidden-link" href={this.href} onClick={this.onAnchorClicked}>{content}</a>
    }

    return content
  },

  computed: {
    href: select(getUriCategory, function (uriCategory) {
      const { levels } = uriCategory

      // When it runs after updating a filter, the document.href (or this.$router) isn't updated
      // yet, so it's necessary to fix the url, getting it from an updated location.
      const makeUrl = fixUrlBuilder(this.$store.state.route.path)

      const path = levels.length > 1 ? `../${this.amenity.path}/` : `./${this.amenity.path}/`

      return makeUrl(path)
    }),
  },

  methods: {
    onAnchorClicked (e) {
      // it prevents the browser to following the link
      e.stopImmediatePropagation()
    },
    onChange (checked, value) {
      const next = checked
        ? Array.from(new Set([...this.value, value]))
        : this.value.filter((i) => i !== value)

      this.$emit('input', next)
      this.$emit('change', checked, next)
    },
  },
})
